import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getPageId, setHospitalTDK } from "utils/hospital";
import ArticleList from "../floor/articleList";
import Template from "../components/template";
import DepartTemplate from "../departPage/departTemplate";

function useParamsForHospitalAndDepartment() {
  let params = useParams<Record<any, any>>();
  console.log("params1", params);
  if (params.did) {
    const _params = { ...params };
    if (params.hid?.indexOf("-") > -1) {
      const hidarr = params.hid?.split("-");
      _params.hid = hidarr?.[0];
      _params.did = hidarr?.[1];
      _params.current = params.did;
      params = _params;
    }
  }
  console.log("params2", params);
  let { pageId: id, current } = getPageId(params.id || params.did);
  const departId = params.did ? id : undefined;
  const pageId = params.hid || id;
  if (params.current !== undefined) {
    current = params.current;
  }

  const info = {
    params,
    pageId,
    departId,
    current,
    id,
  };

  console.log("params3", info);
  return info;
}

// 医生主页
const ArtclePage = () => {
  const paramsInfo = useParamsForHospitalAndDepartment();
  const { params, pageId, departId, current, id } = paramsInfo;

  const TabTemplate = departId ? DepartTemplate : Template;
  return (
    <TabTemplate breadTitle="科普文章">
      {
        (hospitalInfo: any, departInfo?: any) => {
          
          let avtiveName = hospitalInfo?.hospitalName;
          if (departInfo) {
            // 设置TDK
            avtiveName = `${avtiveName}${departInfo?.departName}`;
          }
          setHospitalTDK(
            `${avtiveName}科普文章 - 京东健康互联网医院`,
            `${avtiveName}科普文章`,
            `${avtiveName}科普文章`
          );
          return (
            <ArticleList initData={hospitalInfo} departId={departId} pageId={pageId} current={current} showAll={false} /> 
          )
        }
      }
    </TabTemplate>
  );
};

export default ArtclePage;